document.addEventListener('turbo:load', function () {
  var calendar;

  var calendarEl = document.getElementById('calendar');
  const modal = document.getElementById('supportModal');
  var calendarPaneEl = document.querySelector('#calendarPane');
  const starButtons = document.querySelectorAll('.star-btn');
  const supportButton = document.getElementById('support-trigger');
  const starCountField = document.getElementById('star-count-field');
  const form = document.getElementById('payment-form');
  const customStarCountField = document.querySelector('.custom-star-count');
  const amountField = document.getElementById('amount-field'); //
  const publicKey = supportButton.getAttribute('data-stripe-public-key');

  // console.log('Public Key:', publicKey);
  const stripe = Stripe(publicKey, {
    // Specify betas to opt into Stripe Link
    betas: ['link_beta_1'],
  });
  console.log('Stripe:', stripe);
  const emailError = document.getElementById('emailError'); // Error message element
  const emailInput = document.getElementById('supporterEmail');
  const supporterMessage = document.getElementById('supporter-message').value;

  // Initialize Stripe Elements
  const elements = stripe.elements();

  var supportTrigger = document.getElementById('support-trigger');
  supportTrigger.addEventListener('click', function (event) {
    event.preventDefault();
    modal.style.display = 'flex';
    if (!card) {
      // Initialize Stripe elements if they haven't been already
      const elements = stripe.elements();
      const style = { base: { fontSize: '16px', color: '#32325d' } };
      card = elements.create('card', { style: style });
      card.mount('#card-element');
    }
  });

  // Then you can define your style and create the card element
  const style = {
    base: {
      fontSize: '16px',
      color: '#32325d',
    },
    // Add other styling as needed
  };

  var paymentEmailInput = document.getElementById('paymentEmail');
  const errorElement = document.getElementById('card-errors');
  var displayError = document.getElementById('card-errors');
  const confirmEmailButton = document.getElementById('confirmEmailButton');
  const paymentDetailsContainer = document.getElementById('paymentDetailsContainer');
  const emailInputContainer = document.getElementById('emailInputContainer');
  const submitButton = document.getElementById('submitPaymentButton');
  const paymentForm = document.getElementById('payment-form');
  const artistSlugContainer = document.getElementById('artistSlugContainer');
  const artistSlug2 = artistSlugContainer.getAttribute('data-artist-slug');
  var card = elements.create('card');
  card.mount('#card-element');

  // INFO MODAL

  // Get the modal
  var infoModal = document.getElementById('info-modal');

  // Get the button that opens the modal
  var infoBtn = document.getElementById('info-trigger');

  // Get the elements that close the modal

  var closeInfoBtn = document.getElementById('close-info-modal');

  // When the user clicks the button, open the modal
  infoBtn.onclick = function () {
    infoModal.style.display = 'block';
  };

  // When the user clicks on <span> (x) or "Got it", close the modal
  function closeInfoModal() {
    infoModal.style.display = 'none';
  }

  closeInfoBtn.onclick = function () {
    infoModal.style.display = 'none';
  };

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function (event) {
    if (event.target == infoModal) {
      closeInfoModal();
    }
  };

  // END INFO MODAL

  // GUEST CHECKOUT

  var supportModal = document.getElementById('support-modal');
  var closeButton2 = document.getElementsByClassName('close-button')[0];
  var guestPurchase = document.getElementById('guest-purchase');
  var userSignedInElement = document.getElementById('user-signed-in');
  var userSignedIn = userSignedInElement.value === 'true';

  supportTrigger.addEventListener('click', function () {
    var supportModal = document.getElementById('support-modal');
    var loginModal = document.getElementById('login-modal');
    var closeButton = document.getElementsByClassName('close')[0];
    var closeButton2 = document.getElementsByClassName('close-button')[0];
    var guestPurchase = document.getElementById('guest-purchase');

    if (userSignedIn) {
      console.log('User is signed in');
      // User is signed in, show the normal support modal
      supportModal.style.display = 'block';

      // When the user clicks on <span> (x), close the modal
      if (closeButton) {
        closeButton.onclick = function () {
          supportModal.style.display = 'none';
        };
      }
    } else {
      console.log('User is not signed in');
      // User is not signed in, show the login modal
      loginModal.style.display = 'block';

      guestPurchase.onclick = function () {
        // Handle guest purchase logic here
        console.log('Guest purchase clicked');
        loginModal.style.display = 'none';
        if (supportModal) {
          supportModal.style.display = 'block';
        }
      };
    }
  });

  // END GUEST CHECKOUT

  // function hideModal(modal) {
  //   modal.style.display = 'none';  // Assuming you use inline styles to control visibility
  //   modal.setAttribute('aria-hidden', 'true');  // Accessibility
  // }

  // // Function to show the modal
  // function showModal(modal) {
  //   modal.style.display = 'block';  // Assuming you use inline styles to control visibility
  //   modal.setAttribute('aria-hidden', 'false');  // Accessibility
  // }

  if (form) {
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      const submitButton = document.getElementById('submitPaymentButton'); // Correct the ID here
      submitButton.disabled = true;

      const cardElement = card; // Assuming 'card' is already defined as your Stripe card element
      const { paymentMethod, error } = await stripe.createPaymentMethod({
        type: 'card',
        card: cardElement,
      });

      const errorElement = document.getElementById('card-errors'); // Ensure this ID exists
      if (error) {
        errorElement.textContent = error.message;
        submitButton.disabled = false;
      } else {
        console.log(`Payment method created: ${paymentMethod.id}`);
        await submitPaymentMethod(paymentMethod.id);
      }
    });
  }

  async function submitPaymentMethod(paymentMethodId) {
    const chargeAmount = document.getElementById('hiddenChargeAmount').value;
    const paymentEmailInput = document.getElementById('paymentEmail');
    const artistSlug2 = document.getElementById('artistSlug').value;
    const supporterMessage = document.getElementById('supporter-message').value;
    const supporterName = document.getElementById('supporter-name').value;
    const starCountField = document.getElementById('star-count-field').value; // Assuming this is the correct way to retrieve stars
    const starPurchasesPath = submitButton.dataset.starPurchasesPath; // Retrieve the path from the button's data attribute

    console.log('Supporter Message:', supporterMessage);
    console.log('Supporter Name:', supporterName);

    const payload = {
      payment_method_id: paymentMethodId,
      charge_amount: chargeAmount,
      artist_slug: artistSlug2,
      receipt_email: paymentEmailInput.value,
      stars: starCountField,
      message: supporterMessage,
      supporter_name: supporterName,
      guest_email: paymentEmailInput.value,
    };

    const fetchUrl = `/artists/${artistSlug2}/create_payment`;
    console.log('Request Payload:', payload);

    try {
      const response = await fetch(fetchUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector("[name='csrf-token']").content,
        },
        body: JSON.stringify(payload),
      });

      console.log('Response:', response);
      if (!response.ok) {
        throw new Error('Network response was not okay.');
      }

      const result = await response.json();
      console.log('Result:', result);

      if (result.error) {
        submitButton.disabled = false;
      } else {
        console.log('Payment successful:', result);
        alert(
          "Thank you for your support! Your payment has been successfully processed. You can see your star purchases under 'Recent Supporters' on the artist's page. You will also have a receipt sent to your email.",
        );

        // Check if the user is signed in
        const isUserSignedIn = result.user_signed_in || false;

        // Redirect to the appropriate page based on the user's sign-in status
        if (isUserSignedIn) {
          window.location.href = starPurchasesPath; // Redirect to the star purchases page for signed-in users
        } else {
          window.location.href = `/artists/${artistSlug2}`; // Redirect to the artist show view for guests
        }
      }
    } catch (error) {
      console.error('Error:', error);
      errorElement.textContent = error.message;
      submitButton.disabled = false;
    }
  }

  // Handle real-time validation errors from the card Element
  card.on('change', function (event) {
    if (event.error) {
      errorElement.textContent = event.error.message;
    } else {
      errorElement.textContent = '';
    }
  });

  document.body.addEventListener('submit', function (event) {
    // Check if the target matches your form
    if (event.target && event.target.id === 'payment-form') {
      event.preventDefault();
      // Handle the form submission
    }
  });

  if (displayError) {
    displayError.textContent = '';
    console.log('displayError exists');
    console.log(displayError.textContent);
  } else {
    console.log('displayError does not exist');
  }

  function updateChargeAmount(chargeAmount) {
    let chargeAmountElement = document.getElementById('total-charge-amount');
    let hiddenChargeElement = document.getElementById('hiddenChargeAmount');
    if (chargeAmountElement && hiddenChargeElement) {
      chargeAmountElement.textContent = `$${chargeAmount.toFixed(2)}`;
      hiddenChargeElement.value = chargeAmount.toFixed(2);
    } else {
      console.error('Charge elements not found!');
    }
  }

  function validateEmail(email) {
    const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return re.test(String(email).toLowerCase());
  }

  emailInput.addEventListener('input', function () {
    const isValidEmail = validateEmail(emailInput.value);
    confirmEmailButton.disabled = !isValidEmail; // Enable button if the email is valid
    emailError.style.display = isValidEmail ? 'none' : 'block'; // Show/hide error message
  });

  confirmEmailButton.addEventListener('click', function () {
    const emailInput = document.getElementById('supporterEmail');

    // Directly use the calculated final charge from the previous function
    var finalCharge = parseFloat(document.getElementById('total-charge-amount').textContent.replace(/^\$/, ''));

    const artistSlug = artistSlugContainer.getAttribute('data-artist-slug');
    console.log('Artist Slug:', artistSlug);
    console.log('Email:', emailInput);
    console.log('Final Charge:', finalCharge);

    var paymentEmailInput = document.getElementById('paymentEmail');
    if (paymentEmailInput) {
      paymentEmailInput.value = emailInput.value;
    }

    // Update the charge amount in the payment form
    updateChargeAmount(finalCharge); // Update both display and hidden field for charge amount

    // Toggle visibility of form sections
    document.getElementById('emailInputContainer').style.display = 'none';
    document.getElementById('paymentDetailsContainer').style.display = 'block';

    // Ensure the Stripe card element is correctly mounted if it wasn't already
    if (document.getElementById('card-element')) {
      card.mount('#card-element');
    }
    // Additional re-initialization if needed
  });

  if (supportButton) {
    supportButton.addEventListener('click', function (event) {
      event.preventDefault();
      const starCount = parseInt(document.getElementById('star-count-field').value, 10);
      const supporterMessage = document.getElementById('supporter-message').value;
      const supporterName = document.getElementById('supporter-name').value;
      console.log('Supporter Message:', supporterMessage);
      console.log('Supporter Name:', supporterName);

      updateSupportAmount(starCount);

      // // Close the first modal (assuming `supportModal` is the modal element)
      // hideModal(supportModal);

      // // Assuming you have some way to detect when your custom modal is "closed"
      // // For simplicity, let's assume you can directly call `showModal` after `hideModal`
      // showModal(paymentModal);
    });
  }

  function closeModal() {
    const modal = document.getElementById('supportModal');
    modal.style.display = 'none';
  }

  // Event listener for the close button
  const closeButton = document.querySelector('.close-modal-button');
  closeButton.addEventListener('click', closeModal);

  starButtons.forEach((button) => {
    button.addEventListener('click', function () {
      // This dataset value should represent the number of stars, not the total cost
      const starValue = parseInt(this.dataset.value, 10);
      updateSupportAmount(starValue); // Pass the number of stars to update the amount
    });
  });

  if (customStarCountField) {
    customStarCountField.addEventListener('input', function () {
      // Here, the value represents the number of stars directly entered by the user
      const customStarValue = parseInt(this.value, 10) || 0;
      updateSupportAmount(customStarValue); // Update based on the custom number of stars
    });
  }

  function updateSupportAmount(numberOfStars) {
    const baseStarCost = 5; // Cost per star
    const platformFeePercent = 5; // Platform fee percentage
    const stripeFeePercent = 2.9; // Stripe fee percentage
    const stripeFixedFee = 0.3; // Stripe fixed fee in dollars

    // Calculate initial charge
    const initialCharge = numberOfStars * baseStarCost;

    // Calculate the platform fee
    const platformFee = initialCharge * (platformFeePercent / 100);

    // Calculate Stripe fees
    const stripeFee = initialCharge * (stripeFeePercent / 100) + stripeFixedFee;

    // Calculate total charge
    const finalCharge = initialCharge + platformFee + stripeFee;

    // Format the final charge to two decimal places
    const formattedCharge = finalCharge.toFixed(2);
    console.log('formattedCharge:', formattedCharge);

    document.getElementById('base-charge-amount').textContent = `$${initialCharge.toFixed(2)}`;
    document.getElementById('platform-fee-amount').textContent = `$${platformFee.toFixed(2)}`;
    document.getElementById('stripe-fee-amount').textContent = `$${stripeFee.toFixed(2)}`;
    document.getElementById('total-charge-amount').textContent = `$${finalCharge.toFixed(2)}`;

    // Update the support button and charge amount in the modal
    const supportButton = document.getElementById('support-button');
    if (supportButton) {
      supportButton.textContent = `Support $${initialCharge.toFixed(2)}`;
    }

    const chargeAmountElement = document.getElementById('charge-amount');
    if (chargeAmountElement) {
      chargeAmountElement.textContent = `$${formattedCharge}`;
    }

    const visibleChargeAmountElement = document.getElementById('visible-charge-amount');
    if (visibleChargeAmountElement) {
      visibleChargeAmountElement.textContent = `$${formattedCharge}`;
    }

    const starCountField = document.getElementById('star-count-field');
    if (starCountField) {
      starCountField.value = numberOfStars;
      console.log('starCountField:', starCountField.value);
    }
  }

  // Function to display a success message
  function displaySuccessMessage(container, message) {
    const messageDiv = document.createElement('div');
    messageDiv.textContent = message;
    messageDiv.className = 'alert alert-success'; // Bootstrap class for success messages
    container.prepend(messageDiv);
  }

  // Assume this is called when the payment succeeds

  //This is used for the calendar to pull the artistSlug to pull the events for the artist to display on the calendar rendered on the artist show page
  var artistSlug = document.querySelector('#calendarPane').dataset.artistSlug;
  console.log('Artist Slug:', artistSlug);

  calendar = new FullCalendar.Calendar(calendarEl, {
    headerToolbar: {
      right: 'prev,next today',
      center: 'title',
      left: 'dayGridMonth,timeGridWeek,timeGridDay',
    },
    initialView: 'dayGridMonth',
    events: '/artists/' + artistSlug + '/events', // Use the fetched artistSlug
    height: 'auto',
    eventContent: function (info) {
      // Create a custom element to hold the event title without time
      let titleElement = document.createElement('div');
      titleElement.innerHTML = info.event.title; // Use the event's title without time

      // Return the custom element to be rendered
      return { domNodes: [titleElement] };
    },
    eventDidMount: function (info) {
      // Log the colors to the console for debugging
      console.log('Event ID:', info.event);
      console.log('Background Color:', info.event._def.ui.backgroundColor);
      console.log('Text Color:', info.event._def.ui.textColor);

      // Apply the colors to the event element in FullCalendar
      if (info.event._def.ui.backgroundColor) {
        info.el.style.backgroundColor = info.event._def.ui.backgroundColor;
      }
      if (info.event._def.ui.textColor) {
        info.el.style.color = info.event._def.ui.textColor;
      }
      // Change the dot color if it exists
      const dotElement = info.el.querySelector('.fc-daygrid-event-dot');
      if (dotElement && info.event._def.ui.backgroundColor) {
        dotElement.style.borderColor = info.event._def.ui.textColor;
      }
    },
    eventClick: function (info) {
      info.jsEvent.preventDefault(); // don't let the browser navigate

      // fetch the event page HTML
      fetch(info.event.url)
        .then((response) => response.text())
        .then((data) => {
          var wrapper = document.createElement('div');
          wrapper.innerHTML = data;

          // Remove the navigation bar
          var navbar = wrapper.querySelector('.navbar');
          if (navbar) navbar.remove();

          // Remove the footer
          var footer = wrapper.querySelector('#footer');
          if (footer) footer.remove();

          // Add the modified content to the modal
          document.getElementById('eventModalBody').innerHTML = wrapper.innerHTML;

          // Update the event page link
          document.getElementById('artistShowModalLink').setAttribute('href', info.event.url);
        });

      // Open the Bootstrap modal
      var eventModal = new bootstrap.Modal(document.getElementById('eventModal'), {});
      eventModal.show();
    },
  });

  calendar.render();

  var eventItems = document.querySelectorAll('.event-item');
  eventItems.forEach(function (item) {
    item.addEventListener('click', function (e) {
      e.preventDefault();
      var eventUrl = item.getAttribute('data-event-url');

      // Use similar fetching and modal opening logic as in the calendar eventClick
      fetch(eventUrl)
        .then((response) => response.text())
        .then((data) => {
          var wrapper = document.createElement('div');
          wrapper.innerHTML = data;

          // Remove unnecessary elements
          var navbar = wrapper.querySelector('.navbar');
          if (navbar) navbar.remove();

          var footer = wrapper.querySelector('#footer');
          if (footer) footer.remove();

          // Update modal content and show modal
          document.getElementById('eventModalBody').innerHTML = wrapper.innerHTML;
          document.getElementById('artistShowModalLink').setAttribute('href', eventUrl);

          var eventModal = new bootstrap.Modal(document.getElementById('eventModal'), {});
          eventModal.show();
        });
    });
  });

  document.getElementById('calendar-tab').addEventListener('click', function () {
    // Small timeout to ensure tab pane is visible when updateSize is called
    setTimeout(function () {
      calendar.updateSize();
    }, 100);
  });
});
